import { Dispatch } from 'redux'
import { AnyAction } from '@reduxjs/toolkit'

import { globalStore } from '@app/model/store'
import { RootState } from '@app/model/store'
import { setUserData, setUserLoading } from '@app/model/slice'
import Authorization from '@app/service/authorization'
import SberAuth from '@app/service/sber_auth'

import getSberIdFlag from '@shared/lib/helpers/featureFlag'

export const initAuthAC = () => async (dispatch: Dispatch<AnyAction>) => {
  console.dev('initAuthAC: инициализируем Authorization (SberID или Rambler ID)')

  const isSberID = !getSberIdFlag()

  if (Authorization.isInit && !isSberID) {
    console.dev('initAuthAC: Authorization уже инициализирован')
    return
  }

  if (!isSberID) {
    Authorization.init()
    Authorization.addListener('loginStart', () => dispatch(setUserLoading(true)))
    Authorization.addListener('loginSuccess', (data) => {
      dispatch(setUserData(data))
      dispatch(setUserLoading(false))
    })
    Authorization.addListener('loginError', () => {
      dispatch(setUserLoading(false))
    })

    Authorization.addListener('logoutStart', () => dispatch(setUserLoading(true)))
    Authorization.addListener('logoutSuccess', () => {
      dispatch(setUserData(null))
      dispatch(setUserLoading(false))
    })
    Authorization.addListener('logoutError', () => {
      dispatch(setUserLoading(false))
    })

    Authorization.isAuthorized()
      .then(() => Authorization.login())
      .catch(() => null)
  } else {
    SberAuth.init()
  }
}

export const loginAC = () => {
  const state = (globalStore.getState && globalStore.getState()) as Partial<RootState> | unknown
  const userState = (state as Partial<RootState>)?.global?.user

  if (!userState || userState.loading) return

  const isSberID = !getSberIdFlag()

  if (!isSberID) {
    // Открываем окно авторизации
    Authorization.openAuth()

    // Если пользователь авторизовался на другой площадке то получаем данные и закрываем окно авторизации
    Authorization.login()
  } else {
    SberAuth.login()
  }
}

export const logoutAC = () => async (dispatch: Dispatch<AnyAction>) => {
  const state = (globalStore.getState && globalStore.getState()) as Partial<RootState> | unknown
  const userState = (state as Partial<RootState>)?.global?.user

  if (!userState || userState.loading) return

  const isSberID = !getSberIdFlag()

  if (!isSberID) {
    Authorization.logout()
  } else {
    SberAuth.logout()
  }
}
